import { State } from '../typings/state';

export const selectClientId = (state: State): string =>
    state.commonData.client ? state.commonData.client.ClientID || '' : '';
